import React from 'react';

function StatCard({ label, value, icon, gradient = 'primary' }) {
  return (
    <div className={`stat-card gradient-${gradient}`}>
      {icon && <div className="stat-icon">{icon}</div>}
      <div className="stat-info">
        <span className="stat-label">{label}</span>
        <span className="stat-value">{value}</span>
      </div>
    </div>
  );
}

export default StatCard;
